import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import {MenuCommand, ThreeDotsMenu} from 'front-onceforall-core';

export function createActionDossier(handleClick, label, icon, disabled = false, disabledMessage = '') {
  return {label, icon, handleClick, disabled, disabledMessage};
}

export function createPrintDossier(handleClick, label = 'dossier.print.all', disabled = false) {
  return createActionDossier(handleClick, label, 'print', disabled, I18n.t('organisation.depositorService.noFile'));
}

export function createDownloadDossier(handleClick, label = 'dossier.download.all', disabled = false) {
  return createActionDossier(handleClick, label, 'folder-download', disabled, I18n.t('organisation.depositorService.noFile'));
}

export function createDownloadArchives(handleClick, disabled = false) {
  return createActionDossier(handleClick, 'dossier.download.standardArchives', 'download', disabled, I18n.t('organisation.depositorService.noFile'));
}
export function createDownloadDossierOverview(handleClick, label = 'dossier.download.dossierOverview', disabled = false) {
  return createActionDossier(handleClick, label, 'download', disabled);
}

export function createActionAddDocument(handleClick, disabled = false) {
  return createActionDossier(handleClick, 'dossier.add', 'plus', disabled);
}

export const DossierActions = props => {
  if (props.menuActions.length < 1) {
    return (<div/>);
  }

  const actions = props.menuActions.map((menuAction, index) => (
    <MenuCommand
      label={<Translate value={menuAction.label}/>}
      data-id={`dossier-action-${index}`}
      key={index}
      icon={menuAction.icon}
      onClick={menuAction.handleClick}
      disabled={menuAction.disabled}
      disabledMessage={menuAction.disabledMessage}
    />
  ));

  return (
    <ThreeDotsMenu
      data-id="dossier-actions"
      big={props.big}
    >
      {actions}
    </ThreeDotsMenu>
  );
};

DossierActions.defaultProps = {
  menuActions: [],
  big: false
};

DossierActions.propTypes = {
  menuActions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    disabledMessage: PropTypes.string.isRequired
  })),
  big: PropTypes.bool
};

export default DossierActions;
